function klaviyoSubscribe(email) {
  var settings = {
    'async': true,
    'crossDomain': true,
    'url': 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe',
    'method': 'POST',
    'headers': {
      'content-type': 'application/x-www-form-urlencoded',
      'cache-control': 'no-cache',
    },
    'data': {
      'g': 'JpdkR3',
      '$email': email,
      '$fields': '$source',
      '$source': 'Footer Sign Up',
    },
  };
  $.ajax(settings);
}

export default {
  init() {
    // JavaScript to be fired on the about us page
  },
  finalize() {
    $(document).ready(function() {
      validateBillingInfo();
      if(validateBillingInfo() == true) {
        validatePaymentInfo();
      }
    });

    $(window).on('load', function() {
      $('.woocommerce-account-fields #account_password').parent().append('<span class="show-password"></span>');

      $('.create-account-wrap .show-password').on('click', function() {
        const $field = $(this).parent().find('#account_password');
        const currentType = $field.attr('type');
        $field.attr('type', currentType === 'text' ? 'password' : 'text');
      });

      validateBillingInfo();
      if(validateBillingInfo() == true) {
        validatePaymentInfo();
      }
    });

    function refreshCartCounter() {
        var cartitems = 0;
        $('#cart-items .qty').each(function() { cartitems += parseInt($(this).val()); });

        var counter = $('header.banner .bag .counter');

        counter.text(cartitems);
        if(cartitems <= 0) {
            counter.hide();
        } else {
            counter.show();
        }
    }

    // if(!$('body').hasClass('logged-in')) {
    //   $('.checkout-page.page-2 .col2-set').slideUp();
    // }

    // Function to handle Mailchimp subscribe with Mailchimp for WP plugin
    // function mailchimpSubscribe() {
    //   if ($('#subscribe').is(':checked')) {
    //     const userEmail = $('#billing_email').val();

    //     $.ajax({
    //       type: 'POST',
    //       url: '/wp/wp-admin/admin-ajax.php',
    //       dataType: 'json',
    //       data: {
    //         action: 'bbe_mailchimp_subscribe',
    //         email: userEmail,
    //       },
    //       success: function (response) {
    //       },
    //       error: function (jqXHR, exception) {
    //       },
    //     });
    //   }
    // }

    // Check if fields are filled and valid
    function checkShippingInfo(items) {
      let isValid = true;

      items.each(function() {
        if ($(this).val().length === 0) {
          isValid = false;
        }
      });

      return isValid;
    }

    var checkCreditCardNumberValidation;

    function validatePaymentInfo() {
      $('.bbe-select-box').css('border', 'none');
      if($('#shipping_method li > input').length > 1 && $('#shipping_method li > input:checked').length < 1) {
        $('.bbe-select-box').css('border', '2px solid #ff7976');
        return;
      }
      const stripeElemsIds = ['stripe-card-element', 'stripe-exp-element', 'stripe-cvc-element'];
      let isValid;

      // Check if stripe option exists and checked
      if ($('#payment_method_stripe').length && $('#payment_method_stripe').is(':checked')) {
        $.each(stripeElemsIds, function(i, val) {
          if ($('#' + val).hasClass('StripeElement--complete')) {
            isValid = true;
          } else {
            isValid = false;
          }
        });
      } else {
        isValid = true;
      }

      if (isValid) {
        $('.titlebox__order-review').removeClass('titlebox--blocked');
        clearInterval(checkCreditCardNumberValidation);
      } else {
        $('.titlebox__order-review').addClass('titlebox--blocked');
      }
    }

    function validateBillingInfo() {
      let billingFields = $('.woocommerce-billing-fields').find('.validate-required input');
      let shippingFields = $('.woocommerce-shipping-fields').find('.validate-required input');
      let valid = false;

      let billingFieldsValid = checkShippingInfo(billingFields);
      let shippingFieldsValid = checkShippingInfo(shippingFields);

      const errorMessage = $(this).parents('.titlebox').find('.info-validate-message');

      // if both are valid unlock next step
      if (billingFieldsValid) {
        // check if user select "ship to different address"
        if ($('.woocommerce-shipping-fields .shipping_address').is(':visible')) {
          if (shippingFieldsValid) {
            valid = true;
          }
        } else {
          valid = true;
        }
      }
      if (valid && $('.titlebox__payment').length > 0) {
        errorMessage.hide();
        $('.titlebox__payment').removeClass('titlebox--blocked');
        $([document.documentElement, document.body]).animate({
          scrollTop: $('.titlebox__payment').offset().top - $('header.banner').height() - 50,
        }, 500);

        // The stripe credit card fields are in iframes, so it's not possible to know when they've changed.
        // Stripe adds classes to divs to verify if the fields are filled and valid or not, but it's also not
        // possible to detect class changes. And I'm not able to find any triggers/events to observe.
        // So, i'm just going to check the validity of the entire section every half second.
        // If someone smarter and with more time than me in the future wants to try something else, please do!
        checkCreditCardNumberValidation = setInterval(function() {
          validatePaymentInfo();
        }, 500);
        return true;
      } else {
        errorMessage.show();
        return false;
      }
    }

    function reload() {
      $('body').addClass('bbe-page-reloading');

      setTimeout(() => {
        $('body').removeClass('bbe-page-reloading');
      }, 1000);
    }

    // Read a page's GET URL variables and return them as an associative array.
    function getUrlVars() {
      var vars = [], hash;
      var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
      for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
      }
      return vars;
    }

    $(document).on('click', function(event) {
      if ($(event.target).parents('.bbe-select-box').length === 0) {
        $('.bbe-select-dropdown').hide();
      }
    });

    $('.bbe-select-title').on('click', function() {
      $(this).parents('.bbe-select-box').find('.bbe-select-dropdown').show();
    });

    if ($('.checkout-mobile-nav') && !$('body').hasClass('woocommerce-order-received')) {

      $('.checkout-mobile-menu__item').on('click', function() {
        $('.checkout-mobile-menu__item').removeClass('checkout-mobile-menu__item--active');
        $(this).addClass('checkout-mobile-menu__item--active');
        const step = $(this).data('step');

        if (step === 2) {
          $([document.documentElement, document.body]).animate({
            scrollTop: $('.titlebox__payment').offset().top - $('header.banner').height() - 50,
          }, 500);
        } else if (step === 3) {
          $([document.documentElement, document.body]).animate({
            scrollTop: $('.titlebox__order-review').offset().top - $('header.banner').height() - 50,
          }, 500);
        } else {
          $([document.documentElement, document.body]).animate({
            scrollTop: $('.checkout-page.page-2').offset().top - $('header.banner').height() - 50,
          }, 500);
        }
      });

      $(window).on('scroll', function() {
        const firstStep = $('.checkout-page.page-2').offset().top - 80;
        const secondStep = $('.titlebox__payment').offset().top - 80;
        const thirdStep = $('.titlebox__order-review').offset().top - 80;
        if ($(window).scrollTop() >= thirdStep) {
          $('.checkout-mobile-menu__item').removeClass('checkout-mobile-menu__item--active');
          $('[data-step="3"]').addClass('checkout-mobile-menu__item--active');
        } else if ($(window).scrollTop() >= secondStep) {
          $('.checkout-mobile-menu__item').removeClass('checkout-mobile-menu__item--active');
          $('[data-step="2"]').addClass('checkout-mobile-menu__item--active');
        } else if ($(window).scrollTop() >= firstStep) {
          $('.checkout-mobile-menu__item').removeClass('checkout-mobile-menu__item--active');
          $('[data-step="1"]').addClass('checkout-mobile-menu__item--active');
        }
      });

    }


    $(window).on('load', function() {
      if($('#pay_with_amazon')) {
        const bbe_pay_with_amazon = $('#pay_with_amazon').detach();
        bbe_pay_with_amazon.appendTo($('.quick-checkout-item--amazon'));
      }
    });

    if($('.gift-certificate').length) {
      const certificate = $('.gift-certificate').detach();
      $('#bbe_special_gift_checkbox_field').append(certificate);
    }

    // Amazon Pay Url vars check
    const amazonEnabled = getUrlVars()['amazon_payments_advanced'];
    const amazonLogOut = getUrlVars()['amazon_logout'];
    const amazonAddressBook = $('#amazon_addressbook_widget').length;
    const amazonWalletWidget = $('#amazon_wallet_widget').length;

    if(!amazonLogOut) {
      if (amazonEnabled || amazonAddressBook || amazonWalletWidget) {
        // $('.checkout-shipping-info').hide();

        $('.create-account-wrap').hide();
        $('.checkout-page.page-2 .col2-set').removeClass('part-hidden');

        var amazonShippingMethod = $('#amazon_customer_details').detach();
        //add amazon shipping address method to "shipping info" box
        $('.checkout-shipping-info .titlebox').prepend(amazonShippingMethod);

        // Hide shipping, billing and aditional fields titles,
        // they are not participating in amazon checkout process.
        $('.chekcout-billing-info-title').hide();
        $('.woocommerce-billing-fields, .woocommerce-shipping-fields, .woocommerce-additional-fields').hide();

        //add amazon payment method to "shipping and payment" box
        var amazonPaymentMethod = $('.wc-amazon-payments-advanced-populated').find('.col-2').detach();
        $('.checkout-payment-info .bbe-select-box').after(amazonPaymentMethod);
      }
    }

    // PayPal checkout return
    const paypalEnabled = getUrlVars()['woo-paypal-return'];

    if (paypalEnabled) {
      $('.create-account-wrap').hide();
      $('.checkout-page.page-2 .col2-set').removeClass('part-hidden');
    } else {
      // const payPalBurron = $('#woo_pp_ec_button_checkout').detach();
      // $('.quick-checkout-item--paypal').append(payPalBurron);
    }

      $('#checkout-checkbox-input').change(function () {
          let formCoupon = $(this).closest('.checkout-title').find('.woocommerce-form-coupon');
          let formCouponInput = formCoupon.find('[type="text"]');
          if (this.checked) {
              formCoupon.fadeIn();
              formCouponInput.focus();
          } else {
              formCoupon.fadeOut();
          }
      });


    // $('.woocommerce-remove-coupon').on('click', function (e) {
    //   let url = $(this).attr('href');
    //   let param = getParameterByName('remove_coupon', url);

    //   e.preventDefault();
    //   e.stopPropagation();
    // });

    // stop default scrolling, apply custom which will count header height.
    $(document.body).on('checkout_error', function() {
      $('html, body').stop();

      $([document.documentElement, document.body]).animate({
        scrollTop: $('form.woocommerce-checkout').offset().top - $('header.banner').height() - 50,
      }, 500);
    });

    $(document).on('updated_checkout', function() {

        let shipping_options_count = $('ul#shipping_method input[name*="shipping_method"]').length;
        if(shipping_options_count === 1) {
          $('#shipping_method li:first-child input').prop('checked', true);
        }

        $('.bbe-select-dropdown').find('.bbe-select-dropdown__item').remove();
        const checkedItem = $('#shipping_method li').find('input:checked').next('label').text().split(':');

        let emptyShippingMethods = shipping_options_count > 0 ? 'No shipping methods found' : 'shipping methods are not required';
        let checkedItemLabel = checkedItem[0] ? checkedItem[0] : emptyShippingMethods;
        const checkedItemPrice = checkedItem[1] ? checkedItem[1] : '';


        if (shipping_options_count > 0 && $('#shipping_method li input:checked').length === 0) {
          checkedItemLabel = 'Choose a shipping method';
          $('.shop_table .cart-shipping td').text(checkedItemLabel);
        }

        if (shipping_options_count < 1) {
          $('.bbe-select-box').hide();
          $('.shop_table .cart-shipping').hide();
          $('.bbe-shipping-options-title').hide();
          return;
        } else {
          $('.bbe-select-box').show();
          $('.shop_table .cart-shipping').show();
          $('.bbe-shipping-options-title').show();
        }

        $('.bbe-select-title__label').text(checkedItemLabel);
        $('.bbe-select-title__price').text(checkedItemPrice);

        $('#shipping_method li').each(function() {
          const text = $(this).find('label').text();
          const value = $(this).find('input').val();
          const textArr = text.split(':');
          const label = textArr[0] ? textArr[0] : text;
          const price = textArr[1] ? textArr[1] : '';

          // eslint-disable-next-line quotes
          $('.bbe-select-dropdown').append(`
              <div class="bbe-select-dropdown__item" data-value="${value}" data-label="${label}" data-price="${price}">${text}</div>
          `)
        });
    });



    $('.bbe-select-box').on('click', '.bbe-select-dropdown__item', function() {
      if ($(this).data('label')) {
        $('.bbe-select-title__label').text($(this).data('label'));
      } else {
        $('.bbe-select-title__label').text('no methods');
      }

      if ($(this).data('price')) {
        $('.bbe-select-title__price').text($(this).data('price'));
      } else {
        $('.bbe-select-title__price').text('');
      }

      //update hidden woocommerce radio buttons
      $('input[value="' + $(this).data('value') + '"]').prop('checked', true).trigger('change');
      $(this).parents('.bbe-select-box').find('.bbe-select-dropdown').hide();
    });

    // first step to create account checking the email field.
    $('.create-toggle').click(function(e) {
      e.preventDefault();
      const emailInput = $('#billing_email');
      const emailVal = emailInput.val();
      const nonce = $('#bbe_check_user_nonce').val();

      const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailVal);

      if (valid && emailInput.hasClass('.woocommerce-invalid-email') === false) {
        $('.email-indicator').show();

        const data = {
          action: 'check_user',
          email: emailVal,
          nonce: nonce,
        }

        $.ajax({
          type: 'POST',
          url: '/wp/wp-admin/admin-ajax.php',
          dataType: 'json',
          data,
          success: function(response) {
            if (response.responseText === 'valid') {
              $('#createaccount').prop('checked', true).change();
              $(this).hide();
              $('.create-account-continue').addClass('create-account-next');

              // add email to account registration form
              $('#bbe_email').val(emailVal).trigger('change');
              $('.create-toggle').parents('.titlebox').find('.info-validate-message').hide();
            } else {
              $('.create-toggle').parents('.titlebox').find('.info-validate-message').show();
            }

            $('.email-indicator').hide();
          },
          error: function(response) {
            if (response.responseText === 'valid') {
              $('#createaccount').prop('checked', true).change();
              $(this).hide();
              $('.create-account-continue').addClass('create-account-next');

              // add email to account registration form
              $('#bbe_email').val(emailVal).trigger('change');
              $('.create-toggle').parents('.titlebox').find('.info-validate-message').hide();
            } else {
              $('.create-toggle').parents('.titlebox').find('.info-validate-message').show();
            }

            $('.email-indicator').hide();
          },
        });
      } else {
        alert('Please enter a valid email address!');
      }
    });

    // Show create-account-info form
    $('.create-account__save').on('click', function(e) {
      e.preventDefault();

      const emailVal = $('#billing_email').val();
      klaviyoSubscribe(emailVal);

      // If for some reason result field is visible hide it
      $('.result-message').hide();

      // Collect data from inputs
      var regName = $('#bbe_first_name').val(),
        regLastName = $('#bbe_last_name').val(),
        regUsername = $('#bbe_username').val(),
        regPassword = $('#account_password').val(),
        regEmail = $('#bbe_email').val(),
        regNonce = $('#bbe_new_user_nonce').val();

      if(regName !== '' && regLastName !== '' && regUsername !== '' && regPassword !== '' && regEmail!== '') {
        // Show loader, so user knows that something is going on now
        $('.indicator').show();

        var data = {
          action: 'register_user',
          nonce: regNonce,
          name: regName,
          lastname: regLastName,
          username: regUsername,
          password: regPassword,
          email: regEmail,
        }

        $.ajax({
          type: 'POST',
          url: '/wp/wp-admin/admin-ajax.php',
          dataType: 'json',
          data,
          success: function() {
            // Hide 'Please wait' indicator.
            $('.indicator').hide();

            // Update result message.
            $('.result-message').html('<p>Your submission is complete.</p>').show();

            reload();

            setTimeout(() => {
              // Hide account info and sgow next checkout step.
              $('.create-account-wrap').hide();
              $('.page-2 .col2-set').removeClass('part-hidden');
              $('.create-account-info').hide();
              $('form.woocommerce-checkout .create-account-wrap').hide();

              // Update inputs data on billing form
              $('#billing_first_name').val(data.name).trigger('change');
              $('#billing_last_name').val(data.lastname).trigger('change');

              $('body')[0].scrollIntoView({
                behavior: 'smooth',
              });
            }, 500);

            window.history.pushState({
              page: 2,
            }, '', 'step-2');
          },
          error: function() {

            // Hide 'Please wait' indicator.
            $('.indicator').hide();

            // Update result message.
            $('.result-message').html('<p>Something went wrong, please try again.</p>').show();
          },
        });
      } else {
        alert('Please fill out all required fields!');
      }
    });

    $('.create-account__guest').on('click', function(e) {
      e.preventDefault();
      var regName = $('#bbe_first_name').val(),
        regLastName = $('#bbe_last_name').val();

      const randomstring = Math.random().toString(36).slice(-8);

      $('#account_password').val(randomstring).trigger('change');
      $('#billing_first_name').val(regName);
      $('#billing_last_name').val(regLastName);

      const emailVal = $('#billing_email').val();
      klaviyoSubscribe(emailVal);

      reload();

      setTimeout(() => {
        $('.page-2 .col2-set').removeClass('part-hidden');
        $('.create-account-info').hide();
        $('form.woocommerce-checkout .create-account-wrap').hide();
      }, 500);

      window.history.pushState({
        page: 2,
      }, '', 'step-2');
    });

    window.onpopstate = function(event) {
      reload();

      setTimeout(() => {
        if (event.state) {
          if (event.state.page === 2) {
            $('.checkout-page.page-2 .col2-set').removeClass('part-hidden');
            $('.create-account-info').hide();
            $('form.woocommerce-checkout .create-account-wrap').hide();
          } else if (event.state.page === 1) {
            $('form.woocommerce-checkout .create-account-wrap').hide();
            $('.checkout-page.page-2 .col2-set').addClass('part-hidden');
            $('.create-account-info').show();
          }
        } else if (event.state === null) {
          $('.create-account-info').hide();
          $('.checkout-page.page-2 .col2-set').addClass('part-hidden');
          $('form.woocommerce-checkout .create-account-wrap').show();
          $('.header-mission')[0].scrollIntoView({
            behavior: 'smooth',
          });
        }
      }, 500);
    };

    $('.woocommerce-billing-fields input, .woocommerce-billing-fields select').on('change', function() {
      validateBillingInfo();
    });

    // Hide payment validate message when other checkboxes
    $('#payment').on('click', '.input-radio', function() {
      if (!$(this).prop('checked')) {
        $('.titlebox__payment').find('.info-validate-message').hide();
      }
    });

    $('#shipping_method input').on('change', function() {
      validatePaymentInfo();
    });

    $(document).on('change', '#bbe_special_gift_checkbox', function() {
      if ($(this).prop('checked') === true) {
        $('#bbe-special-gift-message-title').slideDown(200);
      } else {
        $('#bbe-special-gift-message-title').slideUp(200);
      }
    });

    $(document).ajaxComplete((e, r, s) => {
        const $el = $('.checkout-cart .wjecf-fragment-checkout-select-free-product').last().detach();
        if ($el.length > 0) {
            $('.before-customer-details').empty();
            $el.appendTo($('.before-customer-details'));
            $('.checkout-cart .wjecf-fragment-checkout-select-free-product').remove();
        }
        if (s.url === '/?wc-ajax=update_order_review') {
            updateCart();
            if ($el.find('input[type=radio]:checked').length > 0) {
              $('.checkout-shipping-info .titlebox').removeClass('titlebox--blocked');
            } else if ($el.length > 0) {
                $('.checkout-shipping-info .titlebox').addClass('titlebox--blocked');
            }
        }
    });

    let freebieId = '';
    $('.woocommerce-checkout').on('change', '.wjecf-select-free-products input[type=radio]', (event) => {
      if (event.target.value !== freebieId) {
        freebieId = event.target.value;
        $( 'body' ).trigger( 'update_checkout' );
      }
    });

    function updateCart() {
      $('#cart-items').addClass('loading');
      $.ajax({
        type: 'POST',
        url: '/wp/wp-admin/admin-ajax.php',
        dataType: 'json',
        data: {
          action: 'cart_items',
          is_checkout: true,
        },
        success: function(response) {
          $('#cart-items').html(response.cartitems).removeClass('loading');
          $('#cart-count').html(response.cartcount);
          refreshCartCounter();
          // $('.global-cart').addClass('open');
          $('.single_add_to_cart_button').removeClass('loading');
        },
        error: function() {
          $('#cart-items').removeClass('loading');
          $('.single_add_to_cart_button').removeClass('loading');
          alert('An unexpected error occurred! Please try again.');
        },
      });
      return false;
    }

      $(document).on('click', '.checkout_coupon button[name="apply_coupon"]', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const coupon = $('#coupon_code').val();
      const successHtml = `<form class="checkout_coupon woocommerce-form-coupon applied" method="post">
                            <div class="cart-discount code-applied">
                              <p style="margin-bottom: 0;">Coupon code <strong>` + coupon + `</strong> successfully applied!</p>
                              <span class="cart-discount__remove cart-discount__remove--visible"></span>
                            </div>
                          </form>`;
      let wrongHtml = `<form class="checkout_coupon woocommerce-form-coupon applied" method="post">
                            <div class="cart-discount code-applied invalid">
                              <p style="margin-bottom: 0;">Coupon code <strong>` + coupon + `</strong> is Invalid!</p>
                              <span class="cart-discount__remove cart-discount__remove--visible"></span>
                            </div>
                          </form>`;

      $.ajax({
        type: 'POST',
        url: '/wp/wp-admin/admin-ajax.php',
        dataType: 'json',
        data: {
          action: 'bbe_add_coupon_action',
          couponcode: coupon,
          is_checkout: true,
        },
        success: function(response) {
          $('body').trigger('update_checkout');
          if (response.message === 'valid') {
            if (response.refresh_cart === 1) {
              updateCart();
            }

            $('.cart-discount, .woocommerce-form-coupon').html(successHtml);
            $('.checkout-checkbox').hide();
            // $('.cart-discount').append('<span class="cart-discount__remove cart-discount__remove--visible"></span>');

          } else {
            if (response.custom_message) {
              wrongHtml = `<form class="checkout_coupon woocommerce-form-coupon applied" method="post">
                <div class="cart-discount code-applied invalid">
                  <p style="margin-bottom: 0;">${response.custom_message}</p>
                  <span class="cart-discount__remove cart-discount__remove--visible"></span>
                </div>
              </form>`;
            }
            $('.cart-discount, .woocommerce-form-coupon').html(wrongHtml);
            $('.checkout-checkbox').hide();
          }
        },
        error: function(response) {
          $('body').trigger('update_checkout');
          if (response.message === 'valid') {
            if (response.refresh_cart === 1) {
              updateCart();
            }

            $('.cart-discount, .woocommerce-form-coupon').html(successHtml);
            $('.checkout-checkbox').hide();
            // $('.cart-discount').append('<span class="cart-discount__remove cart-discount__remove--visible"></span>');

          } else {
            if (response.custom_message) {
                wrongHtml = `<form class="checkout_coupon woocommerce-form-coupon applied" method="post">
                  <div class="cart-discount code-applied invalid">
                    <p style="margin-bottom: 0;">${response.custom_message}</p>
                    <span class="cart-discount__remove cart-discount__remove--visible"></span>
                  </div>
                </form>`;
            }
            $('.cart-discount, .woocommerce-form-coupon').html(wrongHtml);
            $('.checkout-checkbox').hide();
          }
        },
      });
    });

    // For debugging checkout, without this an unsuccessful checkout will not show any errors
    // $( document.body ).on( 'checkout_error', function(){
    //   var wooError = $('.woocommerce-error li').text();
    //   alert('Error: ' + wooError);
    // });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/checkout.js